import { useMemo } from 'react';
import ShortlistedButtonActions, { SelectedShortlistedProfile } from './ShortlistedButtonActions';
import { useShortlistedTableContext } from './utils/ShortlistedTableContext';
import TableToolbar from '@/Components/Table/TableToolbar';
import UIStrings from '@/Utils/UIStrings';

const ShortlistedListToolbar = () => {
    const table = useShortlistedTableContext();
    const selectedRowsData = useMemo(
        () =>
            table.getSelectedRowModel().rows.map<SelectedShortlistedProfile>(({ original }) => ({
                searchCriteriaScores: original.searchCriteriaScores,
                emailSentCount: original.emailSentCount,
                ...original.profile,
                id: original.id, // important, profile.id is a different id than the shortlisted profile id
            })),
        [table.rowSelection],
    );
    const showButtons = selectedRowsData.length > 0;

    return (
        <TableToolbar>
            {showButtons && (
                <div className="animate-in fade-in slide-in-from-bottom-1 flex flex-row items-center gap-2 duration-200 ease-out">
                    <span className="text-sm font-bold" data-cy="shortlistedSelectionCount">
                        {selectedRowsData.length} {UIStrings.Selected}
                    </span>
                    <ShortlistedButtonActions selectedRows={selectedRowsData} />
                </div>
            )}
        </TableToolbar>
    );
};

export default ShortlistedListToolbar;
